import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Col, Button } from "reactstrap";
import moment from "moment";

import RequestAppointmentModal from "./RequestAppointmentModal";

const Welcome = () => {
  const user = useSelector((state) => state.authentication.user);
  const menuOptions = useSelector(
    (state) => state.litigantMenu.litigantMenuOptions
  );
  return (
    <Row>
      <Col xs={12}>
        <h2>Hi {user ? user.firstName : " "}!</h2>
        {menuOptions && menuOptions.hasAppointment && (
          <p>
            You are currently scheduled for an appointment on
            <Link to="/user/userQuestionnaire" className="sideBarMenuItem">
              <span style={{ fontWeight: "bold" }}>
                {moment(menuOptions.appointmentDate).format(
                  "MMMM Do YYYY, h:mm a"
                )}
                .
              </span>
            </Link>
          </p>
        )}
        {menuOptions && !menuOptions.hasCurrentQuestionnaire && (
          <p>
            Please fill out a{" "}
            <Link to="/user/userQuestionnaire">
              <span>New questionnaire</span>
            </Link>{" "}
            questionnaire in order to begin.
          </p>
        )}
        {menuOptions &&
          menuOptions.hasCurrentQuestionnaire &&
          menuOptions.hasSubmittedRequestInAWeek && (
            <div>
              <p>
                You've requested an appointment. Please be patient, someone will
                contact you soon.
              </p>
            </div>
          )}
        {menuOptions &&
          menuOptions.hasCurrentQuestionnaire &&
          !menuOptions.hasAppointment && (
            <div>
              <p>Now that you have a questionnaire filled out you can </p>
              <Row>
                {menuOptions && menuOptions.hasCurrentQuestionnaire && (
                  <Col xs={3}>
                    <Link to="/user/userQuestionnaire">
                      <Button>Edit current questionnaire</Button>
                    </Link>
                  </Col>
                )}
                {menuOptions &&
                  !menuOptions.hasAppointment &&
                  !menuOptions.hasSubmittedRequestInAWeek && (
                    <Col xs={3}>
                      <RequestAppointmentModal />
                    </Col>
                  )}
              </Row>
            </div>
          )}
        {menuOptions && menuOptions.metYearlyLimitOfThree && (
          <p>
            In order for the court to provide the Pro Se Clinic for everyone we
            limit the appointments to 3 a year. You have met your limit of 3
            appointments for the year. View your{" "}
            <Link to="/user/userQuestionnaire" className="sideBarMenuItem">
              <span>previous appointments</span>
            </Link>
          </p>
        )}
      </Col>
    </Row>
  );
};

export default Welcome;
